import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { IUtilityMapStatus } from 'types';
import { getUtilityMapProcessingMessage } from 'utils/helpers';

interface UtilityMapProcessingWarningProps {
	isResetting?: boolean;
	onReset?: () => Promise<void>;
	status: IUtilityMapStatus | null;
}

export const UtilityMapProcessingWarning: FC<UtilityMapProcessingWarningProps> = ({ isResetting, onReset, status }) => {
	const message = getUtilityMapProcessingMessage(status);

	if (!message) {
		return null;
	}

	return (
		<Box sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: 1 }}>
			<Typography color="error" fontWeight={700}>
				{message}
			</Typography>
			{onReset && (
				<Button
					disabled={isResetting}
					sx={{ fontSize: '14px', fontWeight: 700, lineHeight: '20px', minWidth: 'auto', padding: 0, textTransform: 'none' }}
					variant="text"
					onClick={onReset}
				>
					Зависло? Натисни тут
				</Button>
			)}
		</Box>
	);
};
